import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, ComboBox } from '@components';
import { ContrachequeInitialValues, ContrachequeSchema } from '@schemas';
import { enviaFormRequest } from '@store/user/actions';

export const Contracheque = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <p className="mb-4">
          Venho, por meio deste, solicitar à Fundação Forluminas de Seguridade
          Social - FORLUZ, a alteração de acesso ao demonstrativo de pagamento e
          informe de rendimentos.
        </p>
        <Formik
          validateOnMount
          initialValues={ContrachequeInitialValues}
          validationSchema={ContrachequeSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="acessoContraCheque"
                    label="Acesso ao contracheque via"
                    component={ComboBox}
                    options={['Portal', 'E-mail e portal'].map((x) => {
                      return { value: x, label: x };
                    })}
                  />
                </div>
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="acessoInformeDeRendimentos"
                    label="Acesso ao informe de rendimentos via"
                    component={ComboBox}
                    options={['Portal', 'E-mail e portal'].map((x) => {
                      return { value: x, label: x };
                    })}
                  />
                </div>
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
